import { PATH } from "./path";
import { ApiFindOptions, useApiFind } from "../../../HttpService";

export const useFindAssignees = (options: ApiFindOptions = {}) => useApiFind<any>(PATH, options);
